export default "__VITE_ASSET__DUMZIzQV__"